import LoadingLogo from './LoadingLogo';
import './LoadingOverlay.css';

const LoadingOverlay = ({ text }) => {
  return (
    <div className="loading-overlay">
      <LoadingLogo text={text} />
    </div>
  );
};

export default LoadingOverlay; 